import React from 'react';
import {classes, style} from './doppe-action-type-banner-widget.st.css';
import {DoppeActionGoalType, DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {DoppeActionTypeBanner} from '../doppe-action-type-banner';
import {arrayFirst, asArray, HtmlObjectResizeMode} from '@wix/devzai-utils-common';
import {DoppePageMediaView} from '../../../components/doppe-page-media-view/doppe-page-media-view';
import {doppeHideableValueIsVisibleAndNotEqualValue} from '../../../client-server-common';
import {CommonClasses} from '@wix/devzai-common-client';
import {
    DoppeActionTypeWidgetContentLayoutNewWrapper
} from '../../../components/doppe-action-type-widget-content-layout-new-wrapper/doppe-action-type-widget-content-layout-new-wrapper';


export const DoppeActionTypeBannerWidget = React.memo(function DoppeActionTypeLinkWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypeBanner.ActionSettings>
) {
    const {
        actionContext,

        className,
        ...htmlAttributes
    } = props;

    const hasUrl = doppeHideableValueIsVisibleAndNotEqualValue(actionContext.action.settings.url, '');

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {}, className)}

        >
            <div
                className={style(classes.content, {}, hasUrl ? CommonClasses.button : undefined)}
                onClick={()=>{
                    if (doppeHideableValueIsVisibleAndNotEqualValue(actionContext.action.settings.url, '')) {
                        actionContext.reportGoalAchieved({
                            goalType: DoppeActionGoalType.Click,
                        });
                        actionContext.navigateToUrl(actionContext.action.settings.url, true);
                    }
                }}
            >
                <DoppeActionTypeBannerWidgetInner
                    actionId={actionContext.action.id}
                    actionSettings={actionContext.action.settings}
                />
            </div>
        </div>
    );
});


export const DoppeActionTypeBannerWidgetInner = React.memo(function DoppeActionTypeLinkWidgetInner(
    props: {
        actionSettings: DoppeActionTypeBanner.ActionSettings;
        actionId: string;
    }
) {
    const {
        actionSettings,
    } = props;

    const {
        image,
    } = actionSettings;

    const firstImage = image ? arrayFirst(asArray(image)) : null;

    return (
        <DoppeActionTypeWidgetContentLayoutNewWrapper
            fullWidthMainMedia={true}
            mainMedia={firstImage ? (
                <div
                    className={style(classes.imageContainer, {})}
                >
                    <DoppePageMediaView
                        className={style(classes.image, {})}
                        mediaResource={firstImage}
                        layoutSpec={{autoHeight: true, maxHeight: 860}}
                        widthSpec={{contentRelativeWidth: 1}}
                        mediaResizeMode={HtmlObjectResizeMode.Cover}
                    />
                </div>
            ) : null}
        >
        </DoppeActionTypeWidgetContentLayoutNewWrapper>
    );
});